import {UserManager} from 'oidc-client';
import {createUserManager} from 'redux-oidc';
import {redirectWindowLocation, UserStore} from 'utils';
import {config} from '../../config';

class AuthenticationManager {
  #userManager: UserManager;
  #userStore: UserStore;

  constructor() {
    this.#userManager = createUserManager(config.oidc);
    this.#userStore = new UserStore();
  }

  public getUserManager() {
    return this.#userManager;
  }

  public logout(idToken: string) {
    this.#userManager.clearStaleState();
    this.#userManager.removeUser();
    this.#userManager.revokeAccessToken();
    this.#userStore.removeAllItems();

    if (process.env.REACT_APP_AUTH_PROVIDER === 'b2c') {
      this.#userManager.signoutRedirect({
        extraQueryParams: {
          id_token_hint: idToken,
        },
        post_logout_redirect_uri: process.env.REACT_APP_B2C_POST_LOGOUT_PAGE,
      });
    } else {
      redirectWindowLocation(config.authentication.endSessionUrl);
    }
  }
}

export const authenticationManager = new AuthenticationManager();
